import { ReactElement, useEffect } from 'react';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import { Breakpoints } from 'types/breakpoints';
import { useModalService } from 'hooks/useModalService';
import { ModalTarget, ModalVariant } from 'types/Modal';
import { PageSpinner } from 'components/atoms/PageSpinner';

export const MailWallPage = (): ReactElement => {
  const { show: showModal } = useModalService();

  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);

  useEffect(() => {
    showModal(ModalVariant.MAIL_VERIFICATION, {
      shouldGoBack: true,
      target: isDesktop ? ModalTarget.PAGE_DESKTOP : ModalTarget.PAGE_MOBILE,
    });
  }, [showModal, isDesktop]);

  return <PageSpinner />;
};
